export const NAME = 'name';
export const PARENT_CATEGORY = 'parentId';
export const DESCRIPTION = 'description';
